import React, {Component, lazy, Suspense} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#046AA7' },
    secondary: { main: '#b71c1c' },
  },
  typography: { useNextVariants: true },
});

const Home = lazy(() => import('./screens/Home'));
const Team = lazy(() => import('./screens/Team'));
const Board = lazy(() => import('./screens/Board'));
const Login = lazy(() => import('./screens/Login'));
const Register = lazy(() => import('./screens/Register'));

class AppRouter extends Component {
  render() {
    return (
      <SnackbarProvider>
        <MuiThemeProvider theme={theme}>
          <BrowserRouter>
            <Suspense fallback={LoadingScreen}>
              <Switch>
                <Route path="/" exact={true} component={Home}/>
                <Route path="/team/:tid" exact={true} component={Team}/>
                <Route path="/board/:bid" exact={true} component={Board}/>
                <Route path="/login" exact={true} component={Login}/>
                <Route path="/register" exact={true} component={Register}/>
              </Switch>
            </Suspense>
          </BrowserRouter>
        </MuiThemeProvider>
      </SnackbarProvider>
    );
  }
}

const LoadingScreen = (
  <div>
    Loading
  </div>
)

export default AppRouter;